import React, { useState } from 'react'
import {useDispatch, useSelector} from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { styled } from '@mui/material/styles'
import AppBar from '@mui/material/AppBar'
import Box from '@mui/material/Box'
import Toolbar from '@mui/material/Toolbar'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'
import Menu from '@mui/material/Menu'
import MenuIcon from '@mui/icons-material/Menu'
import Container from '@mui/material/Container'
import Avatar from '@mui/material/Avatar'
import Button from '@mui/material/Button'
import Tooltip from '@mui/material/Tooltip'
import MenuItem from '@mui/material/MenuItem'

import {
  logout
} from '@store/user'
import AbsenteeModal from "./modal/AbsenteeModal";

import {
  getAbsentee,
} from '@store/absentee'

const stringToColor = (string) => {
  let hash = 0
  let i

  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash)
  }

  let color = '#'

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff
    color += `00${value.toString(16)}`.slice(-2)
  }

  return color
}

const stringAvatar = (name) => {
  return {
    sx: {
      bgcolor: stringToColor(name),
    },
    children: `${name.substring(0, 1)}`,
  }
}

const AppHeader = styled(AppBar)({
  paddingLeft: 0,
  backgroundColor: '#fdfdfd',
  color: '#000',
  borderBottom: '1px solid #eee',
  transition: '.2s padding',
  zIndex: 1000,
  '&.open': {
    paddingLeft: 200
  }
})
const Logo = styled(Typography)({
  color: '#000', 
  textDecoration: 'none'
})

const menus = [{
  name: '임원 정보 등록',
  path: '/'
}, {
  name: '게시판',
  path: '/board'
}]
const adminMenus = [{
  name: '모니터링',
  path: '/adminMonitoring'
}, {
  name: '계열기업 관리',
  path: '/adminRole'
}, {
  name: '특관인 변동사항 관리',
  path: '/adminEmployee'
}, {
  name: '공지 게시판 관리',
  path: '/adminBoard'
}]

const Header = () => {
  const navigate = useNavigate()
  const disaptch = useDispatch()
  const { user } = useSelector(store => store.user)
  const [ anchorElNav, setAnchorElNav ] = useState(null)
  const [ anchorElUser, setAnchorElUser ] = useState(null)
  const [ anchorElAdmin, setAnchorElAdmin ] = useState(null)
  const [ absenteeModalOpen, setAbsenteeModalOpen ] = useState(false)

  const settings = [{
    enable: true,
    name: '로그아웃',
    handler: () => handleLogout()
  }]

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget)
  }
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget)
  }
  const handleOpenAdminMenu = (event) => {
    setAnchorElAdmin(event.currentTarget)
  }

  const handleCloseNavMenu = () => {
    setAnchorElNav(null)
  }
  const handleCloseUserMenu = () => {
    setAnchorElUser(null)
  }
  const handleCloseAdminMenu = () => {
    setAnchorElAdmin(null)
  }

  const handleMoveView = (path) => {
    navigate(path)
  }
  const handleMoveAdminView = (path) => {
    handleCloseAdminMenu()
    handleMoveView(path)
  }

  const handleLogout = () => {
    disaptch(logout())
  }

  const handleOpenAbsentee = async () => {
    await disaptch(getAbsentee())
    setAbsenteeModalOpen(pre => !pre)
    handleCloseUserMenu()
  }

  const completeAbsenteeModal = () => {
    setAbsenteeModalOpen(false)
  }

  const isAdmin = () => {
    return user.roles.some(role => role.indexOf('ADMIN') > -1)
  }

  const isClient = () => {
    return user.roles.some(role => role.indexOf('USER') > -1)
  }

  return (
    <>
      <AppHeader
        elevation={0}
      >
        <Container maxWidth="xl">
          <Toolbar disableGutters>
            {/*Mobile*/}
            <Logo
              variant="h6"
              noWrap
              component="a"
              href="/"
              sx={{ mr: 2, display: { xs: 'none', md: 'flex' } }}
            >
              특수관계인
            </Logo>

            <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleOpenNavMenu}
                color="inherit"
              >
                <MenuIcon />
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchorElNav}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'left',
                }}
                open={Boolean(anchorElNav)}
                onClose={handleCloseNavMenu}
                sx={{
                  display: { xs: 'block', md: 'none' },
                }}
              >
                {
                  isAdmin() && adminMenus.map(menu => {
                    return (
                      <MenuItem key={menu.path} onClick={() => handleMoveView(menu.path)}>
                        <Typography textAlign="center">{menu.name}</Typography>
                      </MenuItem>
                    )
                  })
                }
                {
                  isClient() && menus.map(menu => {
                    return (
                      <MenuItem key={menu.path} onClick={() => handleMoveView(menu.path)}>
                        <Typography textAlign="center">{menu.name}</Typography>
                      </MenuItem>
                    )
                  })
                }
              </Menu>
            </Box>

            {/*PC*/}
            <Logo
              variant="h6"
              noWrap
              component="a"
              href="/"
              sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}
            >
              특수관계인
            </Logo>
            <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
              {
                isAdmin() && <>
                  <Button
                    color="inherit"
                    sx={{ my: 2, color: 'black', display: 'block' }}
                    onClick={handleOpenAdminMenu}
                  >관리자</Button>
                  <Menu
                    sx={{ mt: '45px' }}
                    id="menu-appbar"
                    anchorEl={anchorElAdmin}
                    anchorOrigin={{
                      vertical: 'top',
                      horizontal: 'left',
                    }}
                    keepMounted
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'left',
                    }}
                    open={Boolean(anchorElAdmin)}
                    onClose={handleCloseAdminMenu}
                  >
                    {
                      adminMenus.map((menu) => (
                        <MenuItem key={menu.path} onClick={() => handleMoveAdminView(menu.path)}>
                          <Typography textAlign="center">{menu.name}</Typography>
                        </MenuItem>
                      ))
                    }
                  </Menu>
                </>
              }

              {
                isClient() && menus.map(menu => {
                  return (
                    <Button key={menu.path} color="inherit" sx={{ my: 2, color: 'black', display: 'block' }} onClick={() => handleMoveView(menu.path)}>{menu.name}</Button>
                  )
                })
              }
            </Box>

            <Box sx={{ flexGrow: 0 }}>
              <Tooltip title="Open settings">
                <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                  <Avatar {...stringAvatar(user.id)}/>
                </IconButton>
              </Tooltip>
              <Menu
                sx={{ mt: '45px' }}
                id="menu-appbar"
                anchorEl={anchorElUser}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                open={Boolean(anchorElUser)}
                onClose={handleCloseUserMenu}
              >
                {
                  settings
                    .filter(setting => setting.enable)
                    .map((setting, index) => (
                    <MenuItem key={index} onClick={setting.handler}>
                      <Typography textAlign="center">{setting.name}</Typography>
                    </MenuItem>
                  ))
                }
              </Menu>
            </Box>
          </Toolbar>
        </Container>
      </AppHeader>
      <AbsenteeModal open={absenteeModalOpen} completeModal={completeAbsenteeModal}/>
    </>
  )
}
export default Header